export default __webpack_public_path__ + "a97d2eca8d08c4aff94d2d49f1e08818.png";